import React from "react";
import { Trash2, X } from "lucide-react";

const FileDeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />

      {/* Modal Card */}
      <div className="relative bg-white dark:bg-black-primary w-full max-w-md rounded-[32px] overflow-hidden shadow-2xl border dark:border-zinc-800 animate-in fade-in zoom-in duration-200">
        {" "}
        <div className="p-8">
          {/* Close Button (X) */}
          <button
            onClick={onClose}
            className="absolute top-6 right-6 text-gray-400 hover:text-gray-600 dark:text-zinc-500 dark:hover:text-zinc-300 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Delete Icon Circle */}
          <div className="w-12 h-12 rounded-full border border-red-200 dark:border-red-900/30 bg-white dark:bg-zinc-800 flex items-center justify-center mb-6">
            <Trash2 className="w-5 h-5 text-red-500" />
          </div>

          {/* Text Content */}
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {title || "Delete File"}
          </h3>
          <p className="text-gray-500 dark:text-zinc-400 text-[15px] leading-relaxed mb-8 font-medium">
            {description ||
              "Are you sure you want to remove this from your profile?"}
          </p>

          {/* Actions */}
          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3.5 bg-[#F3EFEA] dark:bg-zinc-800 text-gray-900 dark:text-white font-bold rounded-2xl hover:bg-[#e8e2d9] dark:hover:bg-zinc-700 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-6 py-3.5 bg-[#EF4444] text-white font-bold rounded-2xl hover:bg-red-600 transition-all flex items-center justify-center gap-2 shadow-lg shadow-red-100 dark:shadow-none"
            >
              <Trash2 className="w-4 h-4" />
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileDeleteConfirmationModal;
